import { render, staticRenderFns } from "./topico_editor.vue?vue&type=template&id=5f724942&"
import script from "./topico_editor.vue?vue&type=script&lang=js&"
export * from "./topico_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f724942')) {
      api.createRecord('5f724942', component.options)
    } else {
      api.reload('5f724942', component.options)
    }
    module.hot.accept("./topico_editor.vue?vue&type=template&id=5f724942&", function () {
      api.rerender('5f724942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/topicos/topico_editor.vue"
export default component.exports